export enum GraphqlEventTypes {
  CLOSE_SESSION = 'closeSession'
}
